(() => {
  angular
    .module('app')
    .controller(
      'host.views.corporates.createEdit.creditLimit.revokeTemporaryGrant',
      RevokeTemporaryGrantModalController
    );

  RevokeTemporaryGrantModalController.$inject = [
    '$uibModalInstance',
    'abp.services.app.creditLimit',
    'grant',
    'currencyCode',
  ];

  function RevokeTemporaryGrantModalController(
    $uibModalInstance,
    creditLimitSvc,
    grant,
    currencyCode
  ) {
    const vm = this;

    vm.saving = 0;
    vm.grant = grant;
    vm.currencyCode = currencyCode;
    vm.remarks = '';

    vm.save = save;
    vm.cancel = cancel;

    // End this one grant now. The server refuses a grant that has already expired or been revoked.

    function save() {
      // Enter can submit the form while a save is still running.
      if (vm.saving) return;

      if (!App.isFormValid(vm.revokeTemporaryGrantForm)) {
        abp.notify.error(App.localize('GeneralInvalidFormInputError'));
        return;
      }

      vm.saving += 1;
      creditLimitSvc
        .revokeTemporaryCreditLimitGrant({ id: vm.grant.id, remarks: vm.remarks })
        .success(() => {
          abp.notify.success(
            App.localize('CreditLimit_TemporaryGrantRevoked', vm.grant.referenceNumber)
          );
          $uibModalInstance.close(true);
        })
        .finally(() => {
          vm.saving -= 1;
        });
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})();
